import { render, staticRenderFns } from "./PatientListItem.vue?vue&type=template&id=2e01328b&scoped=true&"
import script from "./PatientListItem.vue?vue&type=script&lang=js&"
export * from "./PatientListItem.vue?vue&type=script&lang=js&"
import style0 from "./PatientListItem.vue?vue&type=style&index=0&id=2e01328b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e01328b",
  null
  
)

export default component.exports